/*
 * Copyright (c) Vencode. All rights reserved.
 */

const API_BASE_URL = process.env.API_BASE_URL;
const API_TIMEOUT = parseInt(process.env.API_TIMEOUT, 10);

Office.onReady(async (info) => {
  if (info.host === Office.HostType.Outlook) {
    const result = await getAccessToken();
    if (result.code) {
      const message = getAuthorizationErrorMessage(result);
      showError(message);
      return;
    }

    initializeUI(result);
  }
});

async function getAccessToken() {
  try {
    const accessToken = await OfficeRuntime.auth.getAccessToken({
      allowSignInPrompt: true,
      allowConsentPrompt: true
    });
    return accessToken;
  } catch (error) {
    return error;
  }
}

function initializeUI(accessToken) {
  const analyzeButton = document.getElementById('analyze-button');
  if (analyzeButton) {
    analyzeButton.addEventListener('click', () => {
      if (validateDomainInput()) {
        handleAnalyze(accessToken);
      }
    });
  }

  const retryButton = document.getElementById('retry-button');
  if (retryButton) {
    retryButton.addEventListener('click', () => handleAnalyze(accessToken));
  }

  const analyzeAgainButton = document.getElementById('analyze-again-button');
  if (analyzeAgainButton) {
    analyzeAgainButton.addEventListener('click', () => {
      showState('initial');
      hideValidationError();
    });
  }

  const domainInput = document.getElementById('domain');
  if (domainInput) {
    domainInput.addEventListener('input', () => {
      updateAnalyzeButtonState();
      hideValidationError();
    });
  }

  displayDomain();
  updateAnalyzeButtonState();
}

function extractDomain(input) {
  if (!input || !input.trim()) {
    return null;
  }

  const trimmed = input.trim();

  if (trimmed.includes('@')) {
    const parts = trimmed.split('@');
    if (parts.length === 2 && parts[1]) {
      return parts[1].trim();
    }
    return null;
  }

  return trimmed;
}

function displayDomain() {
  const domainEl = document.getElementById('domain');
  if (!domainEl) return;

  try {
    const item = Office.context.mailbox.item;
    if (item && item.from && item.from.emailAddress) {
      const senderEmail = item.from.emailAddress;
      const domain = senderEmail.split('@')[1];
      if (domain) {
        domainEl.value = domain;
        updateAnalyzeButtonState();
      } else {
        domainEl.placeholder = 'Nie można odczytać domeny nadawcy.';
        updateAnalyzeButtonState();
      }
    } else {
      domainEl.placeholder = 'Nie można odczytać domeny nadawcy.';
      updateAnalyzeButtonState();
    }
  } catch (error) {
    console.error('Get sender domain error:', error);
    domainEl.placeholder = 'Nie można odczytać domeny nadawcy.';
    updateAnalyzeButtonState();
  }
}

function updateAnalyzeButtonState() {
  const domainEl = document.getElementById('domain');
  const analyzeButton = document.getElementById('analyze-button');

  console.log('updateAnalyzeButtonState', domainEl, analyzeButton);
  if (!domainEl || !analyzeButton) return;

  const input = domainEl.value.trim();
  if (input) {
    console.log('input enabled', input);
    analyzeButton.removeAttribute('disabled');
  } else {
    console.log('input disabled', input);
    analyzeButton.setAttribute('disabled', 'disabled');
  }
}

function validateDomainInput() {
  const domainEl = document.getElementById('domain');
  if (!domainEl) {
    showValidationError('Nie można znaleźć pola domeny.');
    return false;
  }

  const input = domainEl.value.trim();
  if (!input) {
    showValidationError('Proszę wpisać domenę lub adres email do analizy.');
    return false;
  }

  const domain = extractDomain(input);
  if (!domain) {
    showValidationError('Nie można wyekstraktować domeny. Wpisz poprawną domenę lub adres email.');
    return false;
  }

  const domainPattern = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (!domainPattern.test(domain)) {
    showValidationError('Nieprawidłowy format domeny.');
    return false;
  }

  hideValidationError();
  return true;
}

function showValidationError(message) {
  const errorEl = document.getElementById('validation-error');
  if (errorEl) {
    errorEl.textContent = message;
    errorEl.style.display = 'block';
  }
}

function hideValidationError() {
  const errorEl = document.getElementById('validation-error');
  if (errorEl) {
    errorEl.style.display = 'none';
  }
}

async function handleAnalyze(accessToken) {
  try {
    showState('loading');
    hideValidationError();

    const domainEl = document.getElementById('domain');
    if (!domainEl) {
      throw new Error('Nie można znaleźć pola domeny.');
    }

    const input = domainEl.value.trim();
    const domain = extractDomain(input);

    if (domain) {
      domainEl.value = domain;
    }

    const result = await analyzeDomain(domain, accessToken);
    displayAnalyzedDomain(domain);
    displayResults(result, accessToken);
    showState('results');
  } catch (error) {
    console.error('Analysis error:', error);
    showError(error.message || 'Wystąpił nieoczekiwany błąd podczas analizy.');
  }
}

async function analyzeDomain(domain, accessToken) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT * 1000);

  try {
    const response = await fetch(`${API_BASE_URL}/analyze`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'AccessToken': accessToken
      },
      body: JSON.stringify({
        domain: domain,
      }),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      let errorMessage = 'Błąd serwera.';
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorData.error || errorMessage;
      } catch (e) {
        errorMessage = await response.text() || errorMessage;
      }
      throw new Error(errorMessage);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      throw new Error('Przekroczono czas oczekiwania na odpowiedź serwera. Spróbuj ponownie.');
    }
    if (error.message.includes('fetch')) {
      throw new Error('Nie można połączyć się z serwerem API. Spróbuj ponownie później.');
    }
    throw error;
  }
}

function displayAnalyzedDomain(domain) {
  const analyzedDomainEl = document.getElementById('analyzed-domain');
  if (analyzedDomainEl) {
    analyzedDomainEl.textContent = domain;
  }
}

function displayResults(data, accessToken) {
  if (!data || !data.risk) {
    throw new Error('Nieprawidłowa odpowiedź serwera.');
  }

  const risk = data.risk;
  displayRiskBanner(risk);
  displayRiskMessage(risk);
  displayCompanyInfo(risk);
  displaySuggestedDomains(risk);
  displayDetectedRisks(risk);

  initializeFeedback(accessToken);
}

function displayRiskBanner(risk) {
  const banner = document.getElementById('risk-banner');
  const icon = document.getElementById('risk-icon');
  const levelEl = document.getElementById('risk-level');

  if (!banner || !icon || !levelEl) return;

  const hasThreats = risk.detectedRisks && risk.detectedRisks.length > 0 &&
    !risk.detectedRisks.some(r => r.includes('Brak wyraźnych') || r.includes('✅') || r.includes('Brak wykrytych'));

  if (!hasThreats) {
    banner.style.display = 'none';
    return;
  }

  banner.style.display = 'flex';
  banner.classList.remove('low', 'medium', 'high');

  let level = risk.level || 'medium';

  // If any threats are detected, show at least low risk
  if (hasThreats && (level !== 'high' && level !== 'medium')) {
    level = 'low';
  }

  banner.classList.add(level);

  const icons = {
    low: '⚠️',
    medium: '⚠️',
    high: '🚨'
  };
  icon.textContent = icons[level] || '⚠️';

  const levelTexts = {
    low: 'Niskie ryzyko',
    medium: 'Średnie ryzyko',
    high: 'Wysokie ryzyko'
  };
  levelEl.textContent = levelTexts[level] || 'Średnie ryzyko';
}

function displayRiskMessage(risk) {
  const messageEl = document.getElementById('risk-message');
  if (messageEl) {
    messageEl.innerHTML = risk.message || 'Brak informacji o ryzyku';
  }
}

function displayCompanyInfo(risk) {
  const card = document.getElementById('company-info-card');
  const logisticsIndicatorEl = document.getElementById('logistics-indicator');
  const descriptionEl = document.getElementById('company-description');
  const detailsEl = document.getElementById('company-details');

  if (!card) return;

  if (!risk.companyInfo) {
    card.style.display = 'none';
    return;
  }

  const info = risk.companyInfo;
  card.style.display = 'block';

  if (logisticsIndicatorEl) {
    if (info.isLogistics !== undefined) {
      logisticsIndicatorEl.style.display = 'block';
      logisticsIndicatorEl.className = info.isLogistics ? 'logistics-indicator positive' : 'logistics-indicator negative';
      logisticsIndicatorEl.textContent = info.isLogistics ? 'Firma logistyczno-spedycyjna' : 'Firma nie jest logistyczno-spedycyjna';
    } else {
      logisticsIndicatorEl.style.display = 'none';
    }
  }

  if (descriptionEl) {
    descriptionEl.textContent = info.description || 'Brak szczegółowych informacji';
  }

  if (detailsEl) {
    detailsEl.innerHTML = '';

    if (info.industry) {
      addDetailItem(detailsEl, 'Branża:', info.industry);
    }

    if (info.websiteUrl) {
      const link = document.createElement('a');
      link.href = info.websiteUrl;
      link.textContent = info.websiteUrl;
      link.target = '_blank';
      link.style.color = '#0078d4';
      link.style.textDecoration = 'none';
      addDetailItem(detailsEl, 'WWW:', link.outerHTML);
    }
  }
}

function addDetailItem(container, label, value) {
  if (!container) return;

  const item = document.createElement('div');
  item.className = 'detail-item';
  item.innerHTML = `
    <span class="detail-label">${escapeHtml(label)}</span>
    <span class="detail-value">${value}</span>
  `;
  container.appendChild(item);
}

function displaySuggestedDomains(risk) {
  const card = document.getElementById('suggested-domains-card');
  const listEl = document.getElementById('suggested-domains-list');

  if (!card || !listEl) return;

  if (!risk.suggestedDomains || risk.suggestedDomains.length === 0) {
    card.style.display = 'none';
    return;
  }

  card.style.display = 'block';
  listEl.innerHTML = '';

  risk.suggestedDomains.forEach(suggestion => {
    const item = document.createElement('div');
    item.className = 'suggestion-item';

    const domain = document.createElement('div');
    domain.className = 'suggestion-domain';
    domain.textContent = suggestion.domain;

    const reason = document.createElement('div');
    reason.className = 'suggestion-reason';
    reason.textContent = suggestion.reason;

    item.appendChild(domain);
    item.appendChild(reason);

    if (suggestion.similarity) {
      const similarity = document.createElement('div');
      similarity.className = 'suggestion-similarity';
      similarity.textContent = `Podobieństwo: ${Math.round(suggestion.similarity)}%`;
      item.appendChild(similarity);
    }

    listEl.appendChild(item);
  });
}

function displayDetectedRisks(risk) {
  const listEl = document.getElementById('detected-risks-list');

  if (!listEl) return;

  listEl.innerHTML = '';

  if (!risk.detectedRisks || risk.detectedRisks.length === 0) {
    const item = document.createElement('li');
    item.className = 'risk-item positive';
    item.textContent = 'Brak wykrytych zagrożeń';
    listEl.appendChild(item);
    return;
  }

  risk.detectedRisks.forEach(riskText => {
    const item = document.createElement('li');
    item.className = 'risk-item';

    if (riskText.includes('Brak wyraźnych') || riskText.includes('✅')) {
      item.classList.add('positive');
    }

    item.innerHTML = riskText;
    listEl.appendChild(item);
  });
}

function getAuthorizationErrorMessage(error) {
  console.error('Authorization error:', error);
  switch (error.code) {
    case 13001:
      return "Nie uwierzytelniono użytkownika. Kod błędu: " + error.code + ". Spróbuj ponownie.";
    case 13002:
      return "Brak zgody na uwierzytelnienie. Kod błędu: " + error.code + ". Spróbuj ponownie.";
    case 13006:
      return "Wystąpił problem z Office na Web. Kod błędu: " + error.code + ". Spróbuj ponownie.";
    case 13008:
      return "Office nadal pracuje nad ostatnią operacją. Kod błędu: " + error.code + ". Spróbuj ponownie.";
    case 13010:
      return "Wystąpił problem z konfiguracją przeglądarki. Kod błędu: " + error.code + ". Spróbuj ponownie.";
    default:
      return "Wystąpił nieznany błąd. Kod błędu: " + error.code + ". Spróbuj ponownie.";
  }
}

function showState(state) {
  const states = ['initial-state', 'loading-state', 'results-state', 'error-state'];
  states.forEach(s => {
    const el = document.getElementById(s);
    if (el) {
      el.style.display = s === `${state}-state` ? 'block' : 'none';
    }
  });
}

function showError(message) {
  const errorEl = document.getElementById('error-message');
  if (errorEl) {
    errorEl.textContent = message;
  }
  showState('error');
}

function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

function getDomain() {
  try {
    const domainEl = document.getElementById('domain');
    if (domainEl && domainEl.value) {
      const input = domainEl.value.trim();
      return extractDomain(input);
    }
    return null;
  } catch (error) {
    console.error('Get domain error:', error);
    return null;
  }
}

function initializeFeedback(accessToken) {
  const textarea = document.getElementById('feedback-textarea');
  const charCount = document.getElementById('feedback-char-count');
  const submitButton = document.getElementById('feedback-submit-button');
  const form = document.getElementById('feedback-form');
  const successMessage = document.getElementById('feedback-success-message');
  const errorMessage = document.getElementById('feedback-error-message');
  const errorText = document.getElementById('feedback-error-text');

  if (!textarea || !charCount || !submitButton) return;

  textarea.addEventListener('input', () => {
    const length = textarea.value.length;
    charCount.textContent = `${length}/500`;
    if (errorMessage && errorMessage.style.display !== 'none') {
      errorMessage.style.display = 'none';
    }
  });

  submitButton.addEventListener('click', async () => {
    const comment = textarea.value.trim();
    if (!comment) {
      return;
    }

    const domain = getDomain();
    if (!domain) {
      showFeedbackError('Nie można pobrać domeny nadawcy.');
      return;
    }

    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
    if (successMessage) {
      successMessage.style.display = 'none';
    }

    const buttonText = submitButton.querySelector('.button-text');

    try {
      submitButton.disabled = true;
      if (buttonText) {
        buttonText.textContent = 'Wysyłanie...';
      }

      await sendFeedback(domain, comment, accessToken);

      form.style.display = 'none';
      successMessage.style.display = 'block';

      setTimeout(() => {
        textarea.value = '';
        charCount.textContent = '0/500';
        form.style.display = 'block';
        successMessage.style.display = 'none';
        if (errorMessage) {
          errorMessage.style.display = 'none';
        }
        submitButton.disabled = false;
        if (buttonText) {
          buttonText.textContent = 'Wyślij';
        }
      }, 3000);
    } catch (error) {
      console.error('Error sending feedback:', error);
      const errorMsg = error.message || 'Wystąpił błąd podczas wysyłania feedbacku. Spróbuj ponownie.';
      showFeedbackError(errorMsg);
      submitButton.disabled = false;
      if (buttonText) {
        buttonText.textContent = 'Wyślij';
      }
    }
  });

  function showFeedbackError(message) {
    if (errorMessage && errorText) {
      errorText.textContent = message;
      errorMessage.style.display = 'block';
      if (successMessage) {
        successMessage.style.display = 'none';
      }
    }
  }
}

async function sendFeedback(domain, comment, accessToken) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT * 1000);

  try {
    const response = await fetch(`${API_BASE_URL}/analyze/feedback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'AccessToken': accessToken
      },
      body: JSON.stringify({
        domain: domain,
        comment: comment
      }),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    const responseText = await response.text();

    if (!response.ok) {
      let errorMessage = 'Błąd serwera.';
      if (responseText) {
        try {
          const errorData = JSON.parse(responseText);
          errorMessage = errorData.message || errorData.error || errorMessage;
        } catch (e) {
          errorMessage = responseText || errorMessage;
        }
      }
      throw new Error(errorMessage);
    }

    if (!responseText) {
      return {};
    }

    try {
      const data = JSON.parse(responseText);
      return data;
    } catch (e) {
      return {};
    }
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      throw new Error('Przekroczono czas oczekiwania na odpowiedź serwera.');
    }
    if (error.message && error.message.includes('fetch')) {
      throw new Error('Nie można połączyć się z serwerem API.');
    }
    throw error;
  }
}